// src/store/notificationSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import React from "react";

interface NotificationState {
  message: React.ReactNode;
  show: boolean;
  isClosedBefore: boolean;
  status: boolean;
}

const initialState: NotificationState = {
  message: "",
  show: false,
  isClosedBefore: false,
  status: false,
};

const notificationBarSlice = createSlice({
  name: "notificationBarSlice",
  initialState,
  reducers: {
    showNotification: (state, action: PayloadAction<React.ReactNode>) => {
      if(state.isClosedBefore) return;
      state.message = action.payload;
      state.show = action.payload ? true : false;
      state.status = !!action.payload; 
    },
    hideNotification: (state) => {
      state.show = false;
      state.message = "";
      state.isClosedBefore= true;
      state.status = false;
    },
  },
});

export const { showNotification, hideNotification } =
  notificationBarSlice.actions;

export default notificationBarSlice.reducer;
